export default __webpack_public_path__ + "static/media/react1.230fb2f0.png";